// §25.7 / §9.1 — Chomp as an in-process app. Gated (D-200); manifest only (D-247).
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export const chompApp: InProcessApp = createLazyApp({
  app: {
    id: 'chomp',
    name: 'Chomp',
    icon: { glyph: 'ghost', hue: 45 },
    keywords: ['maze', 'dots', 'pursuit', 'game', 'arcade'],
    category: 'Arcade',
    // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
    group: 'Action',
    requiresAuth: true,
    // Fixed aspect, letterboxed (D-229): a maze that resized would change how much of it a player
    // can see, which is the whole of the tension.
    window: { width: 760, height: 820, minWidth: 480, minHeight: 520, multiWindow: false },
    jumpList: [{ id: 'new-game', label: 'New game' }],
  },
  load: () => import('./Chomp'),
});
